<script lang="ts">
	import { devices_settings } from 'src/stores/device-runtime/status';
	//Design system components
	import { Toggle, ToggleV2 } from '@Shelly/shelly-design-system';
	//Helpers
	import {
		get_gen_2_component_channel_structure,
		get_gen_2_component_from_category,
		real_id,
	} from '../../../../helpers/interface_helpers';
	import { onSettingsResponse } from '../../../../helpers/device_settings_helpers';
	//Stores
	import {
		getDeviceStatus,
		getDeviceSettings,
		readDeviceSettings,
	} from 'src/stores/device-runtime/status-selectors';
	//Types
	import type { Device } from '../../../../types/Device';
	import type { InputClickEvent } from '../../../../types/InputClickEvent';
	//Services
	import { format } from 'svelte-i18n';
	import { gen2Request } from '../../../../services/gen_2_http_reqs';
	import SettingGuide from '../../SettingGuide.svelte';
	import { showNewLayout } from 'src/stores/toDelete/new_layout';

	export let device: Device;
	export let hideGuide = false;

	const id = real_id(device.id);
	$: settingsStore = getDeviceSettings(id);
	let settings = readDeviceSettings(id);
	$: settings = $settingsStore ?? settings;
	const component = get_gen_2_component_from_category(device);

	let enabled = settings?.[get_gen_2_component_channel_structure(device)]?.autorecover_voltage_errors;
	let loading = false;

	const setAutoRecovery = async (e: InputClickEvent) => {
		loading = true;
		enabled = e.target.checked;
		const params = {
			id: device.channel,
			config: {
				autorecover_voltage_errors: enabled,
			},
		};
		const res = await gen2Request(device, `${component}.SetConfig`, params);
		const response = onSettingsResponse(res, device);
		if (response) {
			settings[get_gen_2_component_channel_structure(device)].autorecover_voltage_errors = enabled;
			devices_settings.update_devices_settings(id, settings);
		} else {
			enabled = !enabled;
		}
		loading = false;
	};

	$: ToggleC = $showNewLayout ? ToggleV2 : Toggle;
</script>

{#if !hideGuide}
	<SettingGuide
		text={$format('settings_guide_voltage_recovery', {
			default:
				'After an over- or undervoltage trip, restore the output to the state it had before the fault once voltage is back to normal. Leave this off if you want the output to stay off until you turn it on again.',
		})}
	/>
{/if}

<svelte:component
	this={ToggleC}
	size="m"
	disabled={loading}
	checked={enabled}
	on:click={setAutoRecovery}
	id="toggle-w632rim"
>
	{$format('settings_toggle_voltage_recovery', {
		default: 'Enable voltage recovery',
	})}
</svelte:component>
